// extracted by mini-css-extract-plugin
export default {"FullScreenPageLayout":"styles_FullScreenPageLayout__461rC"};